import { createStore, applyMiddleware, compose } from 'redux';
import jigsaw from 'app/api/redux-jigsaw/jigsaw-middleware';
import bridge from 'app/api/redux-bridge/bridge-middleware';
import feeny from 'app/api/redux-feeny/middleware';
import reducer from 'app/api/reducer';
import thunk from 'redux-thunk';
import { isDevOrLocal } from 'app/utils/env';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import migrate from './migrations';

let composeEnhancers = compose;
if (isDevOrLocal()) {
  // eslint-disable-next-line no-underscore-dangle
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['knownClasses'],
  version: 0,
  migrate,
};

const persistedReducer = persistReducer(persistConfig, reducer);

const middlewares = applyMiddleware(thunk, jigsaw, bridge, feeny);

export const store = createStore(
  persistedReducer,
  {},
  composeEnhancers(middlewares)
);
export const persistor = persistStore(store);

export function makeTestStore(preloadedState = {}) {
  return createStore(reducer, preloadedState, middlewares);
}
